import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { PasswordUpdateForm } from './PasswordUpdateForm';
import { useAuth } from '@/hooks/useAuth';
import { KeyRound } from 'lucide-react';

export function AdminSelfPasswordUpdate() {
  const { profile } = useAuth();
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!profile) return null;

  const userName = `${profile.first_name || ''} ${profile.last_name || ''}`.trim() || 'Admin';

  return (
    <Card>
      <CardHeader style={{ backgroundColor: 'orange' }}>
        <CardTitle className="flex items-center gap-2">
          <KeyRound className="h-5 w-5" />
          Change My Password
        </CardTitle>
        <CardDescription>
          Update your own admin password
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
          <DialogTrigger asChild>
            <Button onClick={() => setDialogOpen(true)}>
              Change My Password
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle>Update Your Password</DialogTitle>
            </DialogHeader>
            <PasswordUpdateForm
              userId={profile.id}
              userName={userName}
              onSubmit={() => setDialogOpen(false)}
            />
          </DialogContent>
        </Dialog>
      </CardContent>
    </Card>
  );
}
